import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Drawer, Divider, Container, useMediaQuery, IconButton, Box, useTheme } from '@mui/material';
import { ChevronLeftTwoTone } from '@mui/icons-material';
import SideNavBar from '../sideNavBarLayout/sideNavBar';
import Header from '../HeaderLayout/HeaderBar';
import { useAuth } from '../../../contexts/authContext';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
  },
  drawer: {
    width: 240,
    flexShrink: 0,
  },
  drawerPaper: {
    width: 240,
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
    borderRadius: theme.shape.borderRadius,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create(['margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: 240,
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
}));

const Layout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const classes = useStyles();
  const navigate = useNavigate();
  const { user } = useAuth();
  const allowedRoles = ['Admin', 'User'];
  const email = allowedRoles.includes(user.role) ? user.UserEmail : user.IssuerRepEmailID;
  const profileImage = allowedRoles.includes(user.role) ? user.ProfileImageUrl : user.IssuerLogoURL;


  const toggleDrawer = () => setIsDrawerOpen((prev) => !prev);

  return (
    <div className={classes.root}>
      <Header toggleDrawer={toggleDrawer} isDrawerOpen={isDrawerOpen} role={user.role} roles={user.roles} email={email} profileImage={profileImage} />
      <Drawer
        className={classes.drawer}
        variant={isMobile ? 'temporary' : 'permanent'}
        anchor="left"
        open={isMobile ? isDrawerOpen : true}
        onClose={() => setIsDrawerOpen(false)}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          {isMobile && (
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftTwoTone />
            </IconButton>
          )}
        </div>
        <Divider />
        <SideNavBar
          role={user.role}
          handleNavigation={(path) => navigate(path)}
          toggleDrawer={toggleDrawer}
        />
      </Drawer>
      {/* <main className={classes.content}>
        <div className={classes.drawerHeader} />
        <Container>
          <Outlet />
        </Container>
      </main> */}
      {/* Content */}
      <Box
        sx={{
          position: "fixed",
          top: (theme) => isMobile ? theme.spacing(10) : theme.spacing(10),
          left: isMobile ? 0 : 250,
          right: 0,
          bottom: 0,
          overflow: "auto",
          zIndex: 1,
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Outlet />
      </Box>
    </div>
  );
};

export default Layout;
